// extracted by mini-css-extract-plugin
export var bodyRow = "_gr-d";
export var cardColumns = "_gr-e";
export var ellipsesOverflow = "_gr-2";
export var flatBottomCorners = "_gr-3";
export var flatTopCorners = "_gr-4";
export var headerActionsDropdown = "_gr-f";
export var headerBottomRow = "_gr-c";
export var headerTopRow = "_gr-b";
export var orderDetailsWrapper = "_gr-0";
export var orderInfoContainer = "_gr-1";
export var productDetails = "_gr-9";
export var productImage = "_gr-5";
export var responsiveTable = "_gr-8";
export var shipmentContainer = "_gr-a";
export var tableBottomLeft = "_gr-6";
export var tableBottomRight = "_gr-7";
export var trackingLink = "_gr-g";